
import { scoreType, appsType } from '../../types'

const serSubmitionNumbers = (studentInfo: scoreType[][], apps: appsType[]) => {
     
  for (let i = 0; i < studentInfo.length; i++) {
    for (let j = 0; j < apps.length; j++) {
      if (+studentInfo[i][0].lessontype === apps[j].lesson_id || +studentInfo[i][0].lessontype === apps[j].arabic) {
        apps[j].submissions = studentInfo[i].length;
      }
    }
  }

  return apps;
}


export default serSubmitionNumbers;